import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment-timezone';
import Link from 'react-router/lib/Link';
import classNames from 'classnames';

import {
  getStartOfDay,
} from '../../../common/helpers/times';
import config from '../../../../config';
import Icon, { GLYPHS } from '../../../common/icon';

const IncrementalSwitcher = ({ changeDate, currentView, currentDate, timezone, startDate }) => {
  const getDateRange = () => {
    switch (currentView) {
      case 'agendaWeek':
        return 'week';
      case 'month':
        return 'month';
      default:
        return 'day';
    }
  };

  const goNextDate = (e) => {
    e.preventDefault();
    const newDate = moment(currentDate).add(1, getDateRange()).format(config.dateFormatISO);
    changeDate(newDate);
  };

  const goPreviousDate = (e) => {
    e.preventDefault();
    const newDate = moment(currentDate).subtract(1, getDateRange()).format(config.dateFormatISO);
    changeDate(newDate);
  };

  const selectedDayStart = getStartOfDay(timezone, currentDate);
  const start = getStartOfDay(timezone, startDate);
  const prevClass = classNames('c-btn c-btn--outline c-btn--medium u-no-border-radius', {
    'is-disabled': startDate && selectedDayStart.isSameOrBefore(start, 'day'),
  });

  return (
    <div className="o-flexbox c-form-input-group__item">
      <div className="o-flexbox__item c-form-input-group__item">
        <Link
          className={prevClass}
          onClick={goPreviousDate}
          data-automation-id="button:prevDate"
        >
          <Icon glyph={GLYPHS.arrowLeft} />
        </Link>
      </div>
      <div className="o-flexbox__item c-form-input-group__item">
        <Link
          className="c-btn c-btn--outline c-btn--medium"
          onClick={goNextDate}
          data-automation-id="button:nextDate"
        >
          <Icon glyph={GLYPHS.arrowRight} />
        </Link>
      </div>
    </div>
  );
};

IncrementalSwitcher.propTypes = {
  changeDate: PropTypes.func.isRequired,
  currentView: PropTypes.string.isRequired,
  currentDate: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
  startDate: PropTypes.string,
};

export default IncrementalSwitcher;
